import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse, notFoundResponse } from '../../utils/response';
import { Token, UserCode, EmployeeId, EmployeeCode, Company } from '../../utils/users';
import { IsEnglish } from '../../utils/language';
import { encryption } from '../../utils/encryption';

export function getAllContent() {
    let url = 'home/getAllContent?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeId: encryption(EmployeeId()),
        employeeCode: encryption(EmployeeCode()),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortDocument(data) {
    return data.sort(function (a, b) {
        const nameA = a.dateCreated;
        const nameB = b.dateCreated;
        if (nameA > nameB) //sort string descending
            return -1
        if (nameA < nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}